import { useApiClient } from '@klareospace/pharos-lib-front-utils';
import type { Space } from '@klareospace/pharos-lib-types';
import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { createMutationCallbacks } from '@klareospace/pharos-lib-web-utils';

import { createSpaceApi, spaceKeys } from '../api';
import type { UpdateSpaceParams } from '../api';

export function useUpdateSpace(spaceId: string): UseMutationResult<Space, Error, UpdateSpaceParams> {
  const client = useApiClient('admin-auth');
  const api = createSpaceApi(client);
  const queryClient = useQueryClient();

  return useMutation<Space, Error, UpdateSpaceParams>({
    mutationFn: (params: UpdateSpaceParams) => api.updateSpace(spaceId, params),
    ...createMutationCallbacks({
      invalidateKeys: [spaceKeys.all],
      queryClient,
    }),
  });
}
